import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import DesktopAvailableCoins from "../../components/available-coins/DesktopAvailableCoins";
import MobileAvailableCoins from "../../components/available-coins/MobileAvailableCoins";

function ListAvailableCoins({ windowSize, items, apiSort }) {
  return (
    <>
      {windowSize > 576 ? (
        <DesktopAvailableCoins items={items} apiSort={apiSort} />
      ) : (
        <MobileAvailableCoins items={items} />
      )}
    </>
  );
}

ListAvailableCoins.propTypes = {
  items: PropTypes.array.isRequired,
  apiSort: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(ListAvailableCoins);
